import React, { useEffect, useState } from "react";

function LessonTracker({ letter }) {
  const [completed, setCompleted] = useState([]);

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("completedLessons")) || [];
    setCompleted(saved);
  }, []);

  useEffect(() => {
    if (letter) {
      const updated = [...new Set([...completed, letter])];
      setCompleted(updated);
      localStorage.setItem("completedLessons", JSON.stringify(updated));
    }
  }, [letter]);

  return (
    <div className="lesson-tracker">
      <h3>Completed Lessons</h3>
      <ul>
        {completed.map((l, idx) => (
          <li key={idx}>{l}</li>
        ))}
      </ul>
    </div>
  );
}

export default LessonTracker;
